import { HttpParams } from '@angular/common/http';
import { ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { InformationComponent } from '../../core/information/information.component';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CALENDAR_LOCALE, CeleryStatus } from "../../services/constant";
import { TemplateService } from '../../services/template.service';
import { DownloadLogComponent } from '../download-log/download-log.component';
var SubmitToRdComponent = (function () {
    function SubmitToRdComponent(apiService, modalService, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.selectedValues = [];
        this.currentPage = 1;
        this.loading = false;
        this.loading_all_excel = false;
        this.loading_all_excel_message = '';
        this.no_data = true;
        this.value = 0;
        this.sum_docs_count = 0;
        this.errorMsg = '';
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.yearList = [];
        this.allExcelCurrent = 0;
        this.index = 0;
        this.branchList = null;
        this.allBranchList = null;
        this.loading_excel_report = false;
        this.is_TH = false;
        this.tableCol = [];
        this.sendToRdMessage = '';
        this.percentage = 8;
        this.submitting = false;
    }
    SubmitToRdComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cancelSendingTask();
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.populateDropdown();
        });
        this.populateDropdown();
        this.searchData();
    };
    SubmitToRdComponent.prototype.cancelSendingTask = function () {
        if (this.sendingTaskInterval) {
            clearInterval(this.sendingTaskInterval);
        }
    };
    SubmitToRdComponent.prototype.subscribeSendingTaskStatus = function (taskId) {
        var _this = this;
        this.sendingTaskInterval = undefined;
        this.sendingTaskInterval = setInterval(function () {
            _this.apiService.getCeleryTasks({ task_id: taskId }).subscribe({
                next: function (result) {
                    var percentageValue = _.get(result, "percentage", 0);
                    _this.percentage = _.max([percentageValue, _this.percentage]);
                    if ([CeleryStatus.Failure, CeleryStatus.Success].includes(result._state)) {
                        _this.percentage = 100;
                        clearInterval(_this.sendingTaskInterval);
                        if (result._state === CeleryStatus.Success) {
                            _this.submitResult = _this.translate.instant('SUBMIT-TO-RD.SUBMIT-SUCCESS');
                        }
                        else {
                            _this.submitResult = result.detail;
                        }
                        _this.submitting = false;
                    }
                },
                error: function (err) {
                    _this.submitting = false;
                    _this.submitResult = _this.translate.instant('SUBMIT-TO-RD.SUBMIT-ERROR');
                    clearInterval(_this.sendingTaskInterval);
                },
            });
        }, 3000);
    };
    Object.defineProperty(SubmitToRdComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    SubmitToRdComponent.prototype.populateDropdown = function () {
        this.calendarLocale = this.currentLang === 'en'
            ? CALENDAR_LOCALE.EN
            : CALENDAR_LOCALE.TH;
        this.loadCompanyAndBranch();
        this.loadDocumentType();
        this.loadTableHeader();
    };
    SubmitToRdComponent.prototype.loadDocumentType = function () {
        var documentData = this.template.getDropdown();
        documentData[0] = { label: this.translate.instant('COMMON.ALL'), value: null };
        this.rdDocumentType = documentData;
        this.selectedRdDocumentType = null;
    };
    SubmitToRdComponent.prototype.loadTableHeader = function () {
        this.tableCol = [
            { field: 'issue_date', header: this.translate.instant('TABLE.ISSUE-DATE') },
            { field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME') },
            { field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE') },
            { field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS') },
            { field: 'verified_by_acc', header: this.translate.instant('SUBMIT-TO-RD.VERIFIED-BY-ACCOUNT') },
            { field: 'sent_to_rd', header: this.translate.instant('SUBMIT-TO-RD.SENT-TO-RD') },
            { field: 'submit_completely', header: this.translate.instant('SUBMIT-TO-RD.SUBMIT-COMPLETELY') },
        ];
    };
    SubmitToRdComponent.prototype.loadCompanyAndBranch = function () {
        var _this = this;
        this.company = [];
        this.apiService.getCompany().subscribe(function (result) {
            _this.company = [{
                    label: _this.translate.instant('COMMON.ALL'),
                    value: null
                }];
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.selectedCompany = null;
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
    };
    Object.defineProperty(SubmitToRdComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitToRdComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    SubmitToRdComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SubmitToRdComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    SubmitToRdComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    SubmitToRdComponent.prototype.canUserDownloadDoc = function () {
        return true;
    };
    SubmitToRdComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
        });
    };
    SubmitToRdComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchData(params);
    };
    SubmitToRdComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var data = {
            not_submitted_completely: this.notSubmittedCompletely ? this.notSubmittedCompletely : null,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD'),
            company_id: this.selectedCompany ? this.selectedCompany : null,
            branch_id: this.selectedBranch ? this.selectedBranch : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.apiService.postSubmitToRd(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.tableDataDisplay = _this.tableData;
            _this.sum_docs_count = result.sum_docs_count;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
            _this.selectedValues = [];
            for (var i = 0; i < _this.tableData.length; i++) {
                _this.selectedValues.push(false);
            }
            _this.listOfTaxIdLists = result.results.map(function (item) {
                return item['approved_but_not_in_ebxml_taxdataid_list'].concat(item['distinct_replaced_tax_data_id_list']);
            });
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    SubmitToRdComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    SubmitToRdComponent.prototype.confirm = function () {
        var _this = this;
        if (this.modalData.uploaded === false) {
            var params = {
                approved: true,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
        else {
            var params = {
                approved: false,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
    };
    SubmitToRdComponent.prototype.revertBack = function () {
        this.searchData();
        this.modal.close();
    };
    SubmitToRdComponent.prototype.clearData = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.notSubmittedCompletely = false;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.searchButtonClicked();
    };
    SubmitToRdComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' '
                + this.translate.instant('COMMON.CORRECT');
        }
    };
    SubmitToRdComponent.prototype.selectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = this.tableData[i].total_documents === this.tableData[i].total_approved_docs && !this.tableData[i].submit_completely;
        }
    };
    SubmitToRdComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = false;
        }
    };
    SubmitToRdComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            return;
        }
        this.deselectAll();
    };
    SubmitToRdComponent.prototype.EnabledDownloadSelected = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    SubmitToRdComponent.prototype.DownloadExcelReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            not_submitted_completely: this.notSubmittedCompletely ? this.notSubmittedCompletely : null,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD'),
            company_id: this.selectedCompany ? this.selectedCompany : null,
            branch_id: this.selectedBranch ? this.selectedBranch : null,
            rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
        };
        this.apiService.exportExcelSubmitToRd(params).subscribe(function () {
            _this.loading_excel_report = false;
            _this.informUser(_this.translate.instant('COMMON.ADDED-TO-QUEUE'));
        }, function (error) {
            _this.loading_excel_report = false;
            _this.informUser();
        });
    };
    SubmitToRdComponent.prototype.informUser = function (message) {
        var modal = this.modalService.open(InformationComponent, { centered: true });
        modal.componentInstance.message = message || this.translate.instant('ERROR.TRY-AGAIN');
    };
    SubmitToRdComponent.prototype.showDownloadLogs = function () {
        var modal = this.modalService.open(DownloadLogComponent, { size: 'lg' });
        modal.componentInstance.feature = 'submit_to_rd';
    };
    SubmitToRdComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    SubmitToRdComponent.prototype.submitCheckedToRd = function (content) {
        var _this = this;
        var taxDataIdSet = new Set();
        // get only indexes that have been selected
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                for (var j = 0; j < this.listOfTaxIdLists[i].length; j++) {
                    taxDataIdSet.add(this.listOfTaxIdLists[i][j]);
                }
            }
        }
        var taxDataIdArray = Array.from(taxDataIdSet.values());
        if (taxDataIdArray.length === 0) {
            this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.NO-DATA');
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
        }
        else {
            this.submitting = true;
            var params = {
                taxDataIdArray: taxDataIdArray
            };
            this.apiService.submitCheckedToRd(params).subscribe(function (result) {
                _this.modal = _this.modalService.open(_this.submitToRDContent, {
                    backdrop: "static",
                    centered: true,
                    keyboard: false,
                });
                _this.subscribeSendingTaskStatus(result.task_id);
            }, function (error) {
                _this.submitting = false;
            });
        }
    };
    SubmitToRdComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.loading_all_excel = false;
        this.allExcelCurrent = 0;
        this.percentage = 8;
        this.submitResult = undefined;
        this.submitting = false;
        this.searchButtonClicked();
    };
    SubmitToRdComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'SUBMIT_RD',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    SubmitToRdComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return SubmitToRdComponent;
}());
export { SubmitToRdComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.component.ts.pre-build-optimizer.js